import React, { createContext, useState, useCallback } from 'react';
import { nid } from '../utils/helpers';

export const ToastContext = createContext(null);

export function ToastProvider({ children }) {
  const [toasts, setToasts] = useState([]);

  const push = useCallback((message, variant = 'default') => {
    const id = nid('t');
    setToasts((prev) => [...prev, { id, message, variant }]);
    setTimeout(() => setToasts((prev) => prev.filter((t) => t.id !== id)), 3800);
  }, []);

  return (
    <ToastContext.Provider value={push}>
      {children}
      <div className="toasts">
        {toasts.map((t) => (
          <div key={t.id} className={`toast ${t.variant}`}>
            <i className={`ti ${t.variant === 'ok' ? 'ti-check' : t.variant === 'warn' ? 'ti-alert-triangle' : 'ti-info-circle'}`} />
            <span>{t.message}</span>
          </div>
        ))}
      </div>
    </ToastContext.Provider>
  );
}